import React from "react";
import { ReactComponent as FilterIcon } from "assets/icons/filter.svg";
import { classNames } from "helpers/ClassNameHelper";

interface Props {
    text?: string;
    className?: string;
}
export const FilterGroup: React.FC<Props> = ({ text, children, className }) => {
    return (
        <div className={classNames("filter-group", className)}>
            <FilterIcon className="filter-group__icon" />
            {text && <span className="filter-group__text filter-group__text">{text}</span>}
            <div className="filter-group-items">{children}</div>
        </div>
    );
};
